const CHECKLIST_FETCH_FAILED = 'checklist-fetch-failed';
const NO_CHECKLIST_ID_PRESENT = 'no-checklist-id-present';

module.exports = {
  CHECKLIST_FETCH_FAILED,
  NO_CHECKLIST_ID_PRESENT,
};
